import { ArrowUpRight } from "lucide-react";
import { Reveal, MaskedLines } from "@/components/Reveal";
import { PROJECTS } from "@/lib/site";

export default function Projects() {
  return (
    <section id="projects" className="bg-sand py-24 sm:py-32" data-testid="projects-section">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
          <div>
            <Reveal>
              <p className="eyebrow text-arc mb-6">Portfolio</p>
            </Reveal>
            <MaskedLines
              className="font-serif font-medium tracking-tight leading-[1.05] text-charcoal text-4xl sm:text-5xl lg:text-6xl"
              lines={[<>Our <span className="italic text-gradient">Projects.</span></>]}
            />
          </div>
          <Reveal delay={0.15}>
            <p className="max-w-sm text-mist leading-relaxed">
              Explore some of the homes we've helped bring to life.
            </p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {PROJECTS.map((p, i) => (
            <Reveal key={p.address} delay={i * 0.1} className="h-full">
              <article
                className="group h-full bg-cream border border-line flex flex-col overflow-hidden hover:shadow-2xl hover:shadow-charcoal/10 transition-all duration-500"
                data-testid={`project-card-${p.index}`}
              >
                <div className="relative overflow-hidden aspect-[4/3]">
                  <img
                    src={p.image}
                    alt={`Custom home project at ${p.address}`}
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1.2s] ease-out"
                    data-testid={`project-image-${p.index}`}
                  />
                  <span className="absolute top-4 left-4 bg-ink/80 backdrop-blur-sm text-cream font-mono text-[10px] tracking-[0.3em] px-3.5 py-2">
                    PROJECT {p.index}
                  </span>
                </div>
                <div className="flex flex-col flex-1 p-7">
                  <p className="font-mono text-[10px] tracking-[0.28em] uppercase text-arc">{p.suburb}</p>
                  <h3 className="font-serif text-2xl font-medium text-charcoal mt-3 leading-snug">{p.address}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-mist flex-1">{p.description}</p>
                  <a
                    href={p.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`project-view-button-${p.index}`}
                    className="mt-6 inline-flex items-center justify-between border border-charcoal/20 px-6 py-3.5 text-sm font-semibold text-charcoal hover:bg-ink hover:text-cream hover:border-ink transition-all duration-300"
                  >
                    View Project
                    <ArrowUpRight size={16} />
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-8 text-xs text-mist/80" data-testid="projects-imagery-disclaimer">
            Project photos are taken from each address's public listing. Open View Project to see the full listing in a new tab.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
